<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Médico</h3>
      </div>
      <div class="layout__controls" v-show="independiente">
        <div class="form-inline">
          <button @click="guardar" class="btn-success btn--bigger" type="button">
            <i class="fa fa-save"></i>
            <span>Actualizar datos</span>
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <div class="file-upload-field">
            <label>Foto</label>
            <file-upload :disabled="independiente" :defaultImage="srcImagen" ref="fileUpload"></file-upload>
            <button @click="descargarImagen(srcImagen)" class="btn-info btn--text" type="button">
              <i class="fa fa-download"></i>
            </button>
            <button
              :disabled="independiente"
              type="button"
              @click="quitarFoto"
              class="btn-danger btn--text"
            >
              <i class="fa fa-times"></i>
            </button>
          </div>
          <span v-if="errores.imagen" class="helper-text text-danger" slot="helper">
            <strong>{{ errores.imagen[0] }}</strong>
          </span>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <div class="file-upload-field">
            <label>Logo</label>
            <file-upload id="receta" :defaultImage="srcReceta" ref="fileImagenReceta"></file-upload>
            <button @click="descargarImagen(srcReceta)" class="btn-info btn--text" type="button">
              <i class="fa fa-download"></i>
            </button>
            <button type="button" @click="quitarLogo" class="btn-danger btn--text">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <span v-if="errores.logo_receta" class="helper-text text-danger" slot="helper">
            <strong>{{ errores.logo_receta[0] }}</strong>
          </span>
        </div>
      </div>
      <div class="col-xs-12 col-md-6" v-show="false">
        <div class="form-field">
          <div class="file-upload-field">
            <label>Sello</label>
            <file-upload id="sello" :defaultImage="srcSello" ref="fileImagenSello"></file-upload>
            <button @click="descargarImagen(srcSello)" class="btn-info btn--text" type="button">
              <i class="fa fa-download"></i>
            </button>
            <button type="button" @click="quitarSello" class="btn-danger btn--text">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <span v-if="errores.foto_sello" class="helper-text text-danger" slot="helper">
            <strong>{{ errores.foto_sello[0] }}</strong>
          </span>
        </div>
      </div>
      <div class="col-xs-12 col-md-6" v-show="false">
        <div class="form-field">
          <div class="file-upload-field">
            <label>Firma</label>
            <file-upload id="firma" :defaultImage="srcFirma" ref="fileImagenFirma"></file-upload>
            <button @click="descargarImagen(srcFirma)" class="btn-info btn--text" type="button">
              <i class="fa fa-download"></i>
            </button>
            <button type="button" @click="quitarFirma" class="btn-danger btn--text">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <span v-if="errores.foto_firma" class="helper-text text-danger" slot="helper">
            <strong>{{ errores.foto_firma[0] }}</strong>
          </span>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <div class="file-upload-field">
            <label>Contrato</label>
            <file-upload
              id="contrato"
              :disabled="independiente"
              :defaultImage="srcContrato"
              ref="fileUploadContrato"
            ></file-upload>
            <button @click="descargarImagen(srcContrato)" class="btn-info btn--text" type="button">
              <i class="fa fa-download"></i>
            </button>
            <button
              :disabled="independiente"
              type="button"
              @click="quitarContrato"
              class="btn-danger btn--text"
            >
              <i class="fa fa-times"></i>
            </button>
          </div>
          <span v-if="errores.contrato" class="helper-text text-danger" slot="helper">
            <strong>{{ errores.contrato[0] }}</strong>
          </span>
        </div>
      </div>      
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <div class="file-upload-field">
            <label>Archivo Senescyt</label>
            <file-upload
              id="archivo_senescyt"
              :disabled="independiente"
              :defaultImage="srcArchivoSenescyt"
              ref="fileUploadArchivoSenescyt"
            ></file-upload>
            <button @click="descargarImagen(srcArchivoSenescyt)" class="btn-info btn--text" type="button">
              <i class="fa fa-download"></i>
            </button>
            <button
              :disabled="independiente"
              type="button"
              @click="quitarArchivoSenescyt"
              class="btn-danger btn--text"
            >
              <i class="fa fa-times"></i>
            </button>
          </div>
          <span v-if="errores.archivo_senescyt" class="helper-text text-danger" slot="helper">
            <strong>{{ errores.archivo_senescyt[0] }}</strong>
          </span>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <div class="file-upload-field">
            <label>Anexo 1</label>
            <file-upload
              id="anexo_1"
              :disabled="independiente"
              :defaultImage="srcAnexo1"
              ref="fileUploadAnexo1"
            ></file-upload>
            <button @click="descargarImagen(srcAnexo1)" class="btn-info btn--text" type="button">
              <i class="fa fa-download"></i>
            </button>
            <button
              :disabled="independiente"
              type="button"
              @click="quitarAnexo1"
              class="btn-danger btn--text"
            >
              <i class="fa fa-times"></i>
            </button>
          </div>
          <span v-if="errores.anexo_1" class="helper-text text-danger" slot="helper">
            <strong>{{ errores.anexo_1[0] }}</strong>
          </span>
        </div>
      </div>      
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <div class="file-upload-field">
            <label>Anexo 2</label>
            <file-upload
              id="anexo_2"
              :disabled="independiente"
              :defaultImage="srcAnexo2"
              ref="fileUploadAnexo2"
            ></file-upload>
            <button @click="descargarImagen(srcAnexo2)" class="btn-info btn--text" type="button">
              <i class="fa fa-download"></i>
            </button>
            <button
              :disabled="independiente"
              type="button"
              @click="quitarAnexo2"
              class="btn-danger btn--text"
            >
              <i class="fa fa-times"></i>
            </button>
          </div>
          <span v-if="errores.anexo_2" class="helper-text text-danger" slot="helper">
            <strong>{{ errores.anexo_2[0] }}</strong>
          </span>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <div class="file-upload-field">
            <label>Firma electrónica</label>
              <file-upload
                id="firmaElectronica"
                ref="fileUploadFirmaElectronica"
                :defaultImage="srcFirmaElectronica"
                soloFirmaElectronica
              ></file-upload>
              <button @click="descargarImagen(srcFirmaElectronica)" class="btn-info btn--text" type="button">
                <i class="fa fa-download"></i>
              </button>
              <button
                type="button"
                @click="quitarFirmaElectronica"
                class="btn-danger btn--text"
            >
              <i class="fa fa-times"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <div class="datepicker-field">
            <date-picker
              type="date"
              id="fecha_caducidad_firma_electronica"
              v-model="form.fecha_caducidad_firma_electronica"
            ></date-picker>
            <label>Fecha caduc. (Firma Elect.)</label>
            <span v-if="errores.fecha_caducidad_firma_electronica" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.fecha_caducidad_firma_electronica[0] }}</strong>
            </span>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-group">
          <input-field
            :type="!viendoPassword?'password':'text'"
            v-model="form.password_firma_electronica"
            id="password_firma_electronica"
            placeholder="Ingrese la contraseña..."              
          >
            <span>Contraseña firma electr.</span>
            <span
              v-if="errores.password_firma_electronica"
              class="helper-text text-danger"
              slot="helper"
              >{{ errores.password_firma_electronica[0] }}</span
            >
          </input-field>
          <button type="button" @click="verPassword" class="btn-info btn--text"><i :class="{
            'fa-eye': !viendoPassword,
            'fa-eye-slash': viendoPassword
          }" class="fa"></i></button>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            type="password"
            v-model="form.password_firma_electronica_confirmation"
            id="password_firma_electronica_confirmation"
            placeholder="Confirme la contraseña..."            
          >
            <span>Confirm. de cont. de firma elect.</span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            :readonly="independiente"
            id="nombre"
            placeholder="Nombres y apellidos"
            v-model="form.nombre"
          >
            <span>Nombre</span>
            <span v-if="errores.nombre" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.nombre[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            id="codigo_senescyt"
            placeholder="Escriba el código..."
            v-model="form.codigo_senescyt"
          >
            <span>Código Senescyt</span>
            <span
              v-if="errores.codigo_senescyt"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.codigo_senescyt[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div v-show="form.estado !== 'N'" class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            vMoney
            :format="money"
            readonly
            id="saldo_pagar"
            placeholder="$ #,###.##"
            v-model="form.saldo_pagar"
          >
            <span>Saldo por {{ independiente?'cobrar':'pagar' }}</span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            type="password"
            id="clave_acceso"
            placeholder="Clave de acceso"
            v-model="form.clave_acceso"
          >
            <span>Contraseña</span>
            <span v-if="errores.clave_acceso" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.clave_acceso[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            type="password"
            id="clave_acceso_confirmation"
            placeholder="Confirmar clave..."
            v-model="form.clave_acceso_confirmation"
          >
            <span>Confirmación de contraseña</span>
            <span
              v-if="errores.clave_acceso_confirmation"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.clave_acceso_confirmation[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <div class="datepicker-field">
            <date-picker
              :disabled="independiente"
              type="date"
              id="fecha_nacimiento"
              v-model="form.fecha_nacimiento"
            ></date-picker>
            <label>Fecha de nacimiento</label>
            <span v-if="errores.fecha_nacimiento" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.fecha_nacimiento[0] }}</strong>
            </span>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field readonly id="edad" placeholder="Edad" :value="edad">
            <span>Edad</span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field select">
          <div class="select-field">
            <select name="tipo_documento" v-model="form.tipo_documento" id="tipo_documento">
              <option value="C">Cédula</option>
              <option value="R">RUC</option>
              <option value="P">Pasaporte</option>
            </select>
            <label for="tipo_documento">Tipo de documento</label>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            :disabled="independiente"
            v-mask="'#############'"
            id="cedula"
            placeholder="Número de identificación"
            v-model="form.cedula"
          >
            <span>Céd/RUC/Pasaporte</span>
            <span v-if="errores.cedula" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.cedula[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field select2">
          <div class="select2-field">
            <v-select
              v-model="selectedProvincia"
              @input="inputProvincia"
              id="provincia"
              placeholder="Seleccione..."
              :options="provincias"
              label="descripcion"
            ></v-select>
            <label for="provincia">Provincia</label>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field select2">
          <div class="select2-field">
            <v-select
              v-model="selectedCiudad"
              @input="inputCiudad"
              id="ciudad"
              placeholder="Seleccione..."
              :options="ciudades"
              label="descripcion"
            ></v-select>
            <label for="ciudad">Ciudad</label>
            <span v-if="errores.ciudad_id" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.ciudad_id[0] }}</strong>
            </span>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            id="direccion"
            placeholder="Escriba una dirección..."
            v-model="form.direccion"
          >
            <span>Dirección</span>
            <span v-if="errores.direccion" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.direccion[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            id="telefonos"
            placeholder="Escriba uno o varios teléfonos..."
            v-model="form.telefonos"
          >
            <span>Teléfonos</span>
            <span v-if="errores.telefonos" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.telefonos[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            :readonly="independiente"
            id="correo"
            placeholder="Escriba una dirección de correo electrónico..."
            v-model="form.correo"
          >
            <span>Correo electrónico</span>
            <span v-if="errores.correo" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.correo[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <label for="masculino">
          <input
            :disabled="independiente"
            type="radio"
            name="sexo"
            id="masculino"
            v-model="form.sexo"
            value="M"
          />
          <span>Masculino</span>
        </label>
        <label for="femenino">
          <input
            :disabled="independiente"
            type="radio"
            name="sexo"
            id="femenino"
            v-model="form.sexo"
            value="F"
          />
          <span>Femenino</span>
        </label>
      </div>
      <div class="col-xs-12 col-md-6">
        <div
          class="form-field select2"
          :class="{
            'select2--disabled' : independiente
          }"
        >
          <div class="select2-field">
            <v-select
              placeholder="Seleccione..."
              @input="inputEspecialidades"
              id="especialidades"
              :options="especialidades"
              label="descripcion"
              v-model="selectedEspecialidades"
              multiple
            ></v-select>
            <label for="especialidades">Especialidades</label>
            <span v-if="errores.especialidades" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.especialidades[0] }}</strong>
            </span>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <p>
            <label for="es_odontologo">
              <input v-model="form.es_odontologo" type="checkbox" name="es_odontologo" id="es_odontologo"><span>Es odontólogo</span>
            </label>
          </p>
        </div>
      </div>
      
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <p>
            <label for="es_otras_especialidades">
              <input v-model="form.es_otras_especialidades" type="checkbox" name="es_otras_especialidades" id="es_otras_especialidades"><span>Tiene otras especialidades</span>
            </label>
          </p>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field select">
          <div class="select-field">
            <select name="tipo_cuenta" id="tipo_cuenta" v-model="form.tipo_cuenta">
              <option value="A">Ahorros</option>
              <option value="C">Corriente</option>
            </select>
            <label for="tipo_cuenta">Tipo de cuenta</label>
            <span
              v-if="errores.tipo_cuenta"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.tipo_cuenta[0] }}</strong>
            </span>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field v-mask="'####################'" id="numero_cuenta" v-model="form.numero_cuenta" placeholder="Especifique...">
            Número de cuenta
            <span
              v-if="errores.numero_cuenta"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.numero_cuenta[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field id="nombre_cuenta" v-model="form.nombre_cuenta" placeholder="Especifique...">
            Nombre de propietario
            <span
              v-if="errores.nombre_cuenta"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.nombre_cuenta[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field select">
          <div class="select-field">
            <select
              name="tipo_identificacion_cuenta"
              v-model="form.tipo_identificacion_cuenta"
              id="tipo_identificacion_cuenta"
            >
              <option value="C">Cédula</option>
              <option value="R">RUC</option>
              <option value="P">Pasaporte</option>
            </select>
            <label for="tipo_identificacion_cuenta">Tipo de documento de propietario</label>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field v-mask="'####################'" id="identificacion_cuenta" v-model="form.identificacion_cuenta" placeholder="Especifique...">
            Identificación del propietario
            <span
              v-if="errores.identificacion_cuenta"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.identificacion_cuenta[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field id="banco" v-model="form.banco" placeholder="Especifique...">
            Nombre del banco
            <span
              v-if="errores.banco"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.banco[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <textarea-field
            :max="500"
            id="comentario"
            placeholder="Escriba un comentario..."
            v-model="form.comentario"
          >
            <span>Comentario</span>
            <span v-if="errores.comentario" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.comentario[0] }}</strong>
            </span>
          </textarea-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            vMoney
            :format="decimal5"
            v-model="form.latitud"
            id="latitud"
            placeholder="Escriba la latitud..."
          >
            <span>Latitud</span>
            <span v-if="errores.latitud" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.latitud[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            vMoney
            :format="decimal5"
            v-model="form.longitud"
            id="longitud"
            placeholder="Escriba la longitud..."
          >
            <span>Longitud</span>
            <span v-if="errores.longitud" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.longitud[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-inline">
          <button @click="validarCoordenadas" type="button" class="btn-primary btn--text">
            <i class="fa fa-check"></i>
            <span>Validar coordenadas</span>
          </button>
          <button @click="quitarCoordenadas" type="button" class="btn-danger btn--text">
            <i class="fa fa-times"></i>
            <span>Quitar coordenadas</span>
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <l-map style="width:100%; height:250px;" :zoom="zoom" :center="center" ref="map">
          <l-tile-layer :url="urlLayer"></l-tile-layer>
          <l-marker draggable @update:latLng="actualizarCoordenadas" :lat-lng="markerPosition"></l-marker>
        </l-map>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-md-6">
        <multiple-fotos v-model="form.fotos"></multiple-fotos>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <textarea-field
            :max="800"
            rows="7"
            id="biografia"
            placeholder="Escriba una corta biografía..."
            v-model="form.biografia"
          >
            <span>Biografía</span>
            <span v-if="errores.biografia" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.biografia[0] }}</strong>
            </span>
          </textarea-field>
        </div>
      </div>
    </div>
    <div v-show="!independiente" class="modal-buttons">
      <button @click="guardar" class="btn-success" type="button">
        <i class="fa fa-save"></i>
        <span>Guardar</span>
      </button>
      <button @click="$emit('cancelar')" class="btn-danger btn--text" type="button">
        <i class="fa fa-ban"></i>
        <span>Cancelar</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  mounted: function() {
    if (
      this.form.latitud !== "" &&
      this.form.longitud !== "" &&
      this.form.latitud != null &&
      this.form.longitud != null
    ) {
      this.markerPosition = [this.form.latitud, this.form.longitud];
      this.center = [this.form.latitud, this.form.longitud];
    }
    for (let i = 0; i < this.especialidades.length; i++) {
      for (let j = 0; j < this.form.especialidades.length; j++) {
        if (this.form.especialidades[j] == this.especialidades[i].id) {
          this.selectedEspecialidades.push(this.especialidades[i]);
        }
      }
    }
    if (this.form.imagen !== null && this.form.imagen !== "")
      this.srcImagen = this.form.imagen;
    if (this.form.logo_receta !== null && this.form.logo_receta !== "")
      this.srcReceta = this.form.logo_receta;
    if (this.form.foto_sello !== null && this.form.foto_sello !== "")
      this.srcSello = this.form.foto_sello;
    if (this.form.foto_firma !== null && this.form.foto_firma !== "")
      this.srcFirma = this.form.foto_firma;
    if (this.form.contrato !== null && this.form.contrato !== "")
      this.srcContrato = this.form.contrato;
    if (this.form.path_firma_electronica !== null && this.form.path_firma_electronica !== "")
      this.srcFirmaElectronica = this.form.path_firma_electronica;
    if (this.form.archivo_senescyt !== null && this.form.archivo_senescyt !== "")
      this.srcArchivoSenescyt = this.form.archivo_senescyt;
    if (this.form.anexo_1 !== null && this.form.anexo_1 !== "")
      this.srcAnexo1 = this.form.anexo_1;
    if (this.form.anexo_2 !== null && this.form.anexo_2 !== "")
      this.srcAnexo2 = this.form.anexo_2;
    for (let i = 0; i < this.provincias.length; i++)
      if (this.form.provincia_id == this.provincias[i].id_provincia) {
        this.selectedProvincia = this.provincias[i];
        this.cargarCiudades();
        break;
      }
    this.inputEspecialidades();
  },
  props: {
    independiente: {
      type: Boolean,
      required: false,
      default: false
    },
    value: {
      type: Object,
      required: true
    },
    especialidades: {
      type: Array,
      required: false,
      default: function() {
        return [];
      }
    },
    maximo_especialidades: {
      type: Number,
      required: false,
      default: 3
    },
    provincias: {
      type: Array,
      required: false,
      default: function() {
        return [];
      }
    },
    limiteEdad: {
      type: Number,
      required: false,
      default: 18
    }
  },
  computed: {
    editando: function() {
      return this.form.estado !== "N";
    },
    edad: function() {
      if (
        this.form.fecha_nacimiento != null &&
        this.form.fecha_nacimiento.length === 10
      ) {
        let date = new Date(this.form.fecha_nacimiento);
        if (date != "Invalid Date")
          return moment(new Date()).diff(date, "years");
      }
      return "";
    }
  },
  data: function() {
    return {
      srcContrato: "",
      srcArchivoSenescyt: '',
      srcAnexo1: '',
      srcAnexo2: '',
      money: money,
      zoom: 17,
      center: [-2.1602304, -79.9080448],
      markerPosition: [-2.1602304, -79.9080448],
      urlLayer: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      selectedCiudad: null,
      selectedProvincia: null,
      form: JSON.parse(JSON.stringify(this.value)),
      errores: {},
      selectedEspecialidades: [],
      srcImagen: "",
      srcReceta: "",
      srcSello: "",
      srcFirma: "",
      srcContrato: "",
      srcFirmaElectronica: "",
      ciudades: [],
      decimal5: decimal5,
      viendoPassword: false,
    };
  },
  methods: {
    verPassword: function() {
      this.viendoPassword = !this.viendoPassword;
    },
    quitarAnexo1: function() {
      this.form.anexo_1 = "N/I";
      this.$refs.fileUploadAnexo1.resetImagen();
    },
    quitarAnexo2: function() {
      this.form.anexo_2 = "N/I";
      this.$refs.fileUploadAnexo2.resetImagen();
    },
    quitarArchivoSenescyt: function() {
      this.form.archivo_senescyt = "N/I";
      this.$refs.fileUploadArchivoSenescyt.resetImagen();
    },
    quitarContrato: function() {
      this.form.contrato = "N/I";
      this.$refs.fileUploadContrato.resetImagen();
    },
    quitarFirmaElectronica: function() {
      this.form.path_firma_electronica = "N/I";
      this.$refs.fileUploadFirmaElectronica.resetImagen();
    },
    quitarFirma: function() {
      this.form.foto_firma = "N/I";
      this.$refs.fileImagenFirma.resetImagen();
    },
    quitarSello: function() {
      this.form.foto_sello = "N/I";
      this.$refs.fileImagenSello.resetImagen();
    },
    quitarLogo: function() {
      this.form.logo_receta = "N/I";
      this.$refs.fileImagenReceta.resetImagen();
    },
    quitarFoto: function() {
      this.form.imagen = "N/I";
      this.$refs.fileUpload.resetImagen();
    },
    descargarImagen: function(img) {
      if (img != null && img !== "") {
        let link = document.createElement("a");
        let filename = img.substring(img.lastIndexOf("/") + 1);
        link.download = filename;
        link.href = img;
        link.click();
      } else swal("No hay archivo para descargar.", "Aviso", "warning");
    },
    actualizarCoordenadas: function(latLng) {
      this.form.latitud = latLng.lat;
      this.form.longitud = latLng.lng;
    },
    quitarCoordenadas: function() {
      this.form.latitud = "";
      this.form.longitud = "";
    },
    validarCoordenadas: function() {
      if (this.form.latitud !== "" && this.form.longitud !== "") {
        this.markerPosition = [
          parseFloat(this.form.latitud),
          parseFloat(this.form.longitud)
        ];
        this.center = [
          parseFloat(this.form.latitud),
          parseFloat(this.form.longitud)
        ];
      } else
        swal("Debe ingresar la latitud y la longitud.", "Aviso", "warning");
    },
    cargarCiudades: function() {
      let that = this;
      axios
        .get(url + "/ciudades/" + this.selectedProvincia.id_provincia)
        .then(function(response) {
          that.ciudades = response.data;
          for (let i = 0; i < that.ciudades.length; i++)
            if (that.ciudades[i].id_ciudad == that.form.ciudad_id) {
              that.selectedCiudad = that.ciudades[i];
              break;
            }
        });
    },
    inputProvincia: function() {
      this.selectedCiudad = null;
      if (this.selectedProvincia !== null) {
        this.form.provincia_id = this.selectedProvincia.id_provincia;
        this.cargarCiudades();
      } else this.form.provincia_id = "";
    },
    inputCiudad: function() {
      if (this.selectedCiudad !== null)
        this.form.ciudad_id = this.selectedCiudad.id_ciudad;
      else this.form.ciudad_id = "";
    },
    cargarImagen: function() {
      if (this.form.imagen !== "N/I")
        this.form.imagen = this.$refs.fileUpload.recuperarImagen();
    },
    cargarImagenSello: function() {
      if (this.form.foto_sello !== "N/I")
        this.form.foto_sello = this.$refs.fileImagenSello.recuperarImagen();
    },
    cargarImagenFirma: function() {
      if (this.form.foto_firma !== "N/I")
        this.form.foto_firma = this.$refs.fileImagenFirma.recuperarImagen();
    },
    cargarImagenReceta: function() {
      if (this.form.logo_receta !== "N/I")
        this.form.logo_receta = this.$refs.fileImagenReceta.recuperarImagen();
    },
    cargarContrato: function() {
      if (this.form.contrato !== "N/I")
        this.form.contrato = this.$refs.fileUploadContrato.recuperarImagen();
    },
    cargarFirmaElectronica: function() {
      if (this.form.path_firma_electronica !== "N/I")
        this.form.path_firma_electronica = this.$refs.fileUploadFirmaElectronica.recuperarImagen();
    },
    cargarArchivoSenescyt: function() {
      if (this.form.archivo_senescyt !== "N/I")
        this.form.archivo_senescyt = this.$refs.fileUploadArchivoSenescyt.recuperarImagen();
    },
    cargarAnexo1: function() {
      if (this.form.anexo_1 !== "N/I")
        this.form.anexo_1 = this.$refs.fileUploadAnexo1.recuperarImagen();
    },
    cargarAnexo2: function() {
      if (this.form.anexo_2 !== "N/I")
        this.form.anexo_2 = this.$refs.fileUploadAnexo2.recuperarImagen();
    },
    inputEspecialidades: function() {
      this.form.especialidades.splice(0, this.form.especialidades.length);
      for (let i = 0; i < this.selectedEspecialidades.length; i++) {
        this.form.especialidades.push(this.selectedEspecialidades[i].id);
      }
    },
    guardar: function() {
      if (
        (this.form.latitud !== "" && this.form.longitud === "") ||
        (this.form.longitud !== "" && this.form.latitud === "")
      ) {
        swal(
          "Debe ingresar la latitud y la longitud en caso de haber ingresado alguna de las dos.",
          "Aviso",
          "warning"
        );
        return;
      }
      if (this.form.password_firma_electronica != this.form.password_firma_electronica_confirmation) {
        swal(
          "La contraseña de la firma electrónica no coincide con la confirmación",
          "Aviso",
          "warning"
        );
        return;
      }
      if (this.edad !== "" && this.edad < this.limiteEdad) {
        swal("La edad mínima es: " + this.limiteEdad + ".", "Aviso", "warning");
        return;
      }
      if (this.selectedEspecialidades.length > this.maximo_especialidades) {
        swal("Se puede asignar hasta 3 especialidades.", "Aviso", "warning");
        return;
      }
      for (let i = 0; i < this.form.fotos.length; i++)
        if (
          this.form.fotos[i].imagen == null ||
          this.form.fotos[i].imagen == ""
        ) {
          swal(
            "No ha agregado todas las fotos en la tabla.",
            "Aviso",
            "warning"
          );
          return;
        }
      let that = this;
      let urlRequest = url + "/doctores";
      if (this.editando) {
        urlRequest += "/" + this.form.id;
        that.form._method = "PUT";
      } else that.form._method = undefined;
      this.cargarImagen();
      this.cargarImagenSello();
      this.cargarImagenFirma();
      this.cargarImagenReceta();
      this.cargarContrato();
      this.cargarFirmaElectronica();
      this.cargarArchivoSenescyt();
      this.cargarAnexo1();
      this.cargarAnexo2();
      axios
        .post(urlRequest, this.form)
        .then(function(response) {
          swal("El médico fue almacenado.", "Realizado", "success");
          that.$emit("saved", response.data);
        })
        .catch(function(error) {
          if (error && error.response) {
            let response = error.response;
            let status = response.status;
            switch (status) {
              case 422:
                that.errores = response.data.errors;
                swal("Hay errores en el formulario.", "Aviso", "warning");
                return;
            }
          }
          swal("Hubo un error, intente nuevamente.", "Error", "error");
        });
    },
    cancelar: function() {
      this.$emit("cancelar");
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/doctores/Doctor.vue